import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./CookieNotice.scss";

const STORAGE_KEY = "cookieNoticeAccepted";

/**
 * Информационная (неблокирующая) плашка об использовании cookie.
 * Сервис устанавливает только технические cookie, поэтому плашка
 * не запрашивает согласия, а лишь уведомляет Пользователя (п. 3.1 Политики).
 */
export const CookieNotice = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      setVisible(localStorage.getItem(STORAGE_KEY) !== "true");
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "true");
    } catch {
      // localStorage недоступен — просто закрываем плашку
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-notice" role="region" aria-label="Уведомление об использовании cookie">
      <p className="cookie-notice__text">
        Сайт использует только технические cookie, необходимые для работы сервиса
        (аутентификация, настройки). Маркетинговые cookie не устанавливаются.
        Подробнее — в <Link to="/privacy">Политике конфиденциальности</Link>.
      </p>
      <button className="cookie-notice__button" type="button" onClick={accept}>
        Понятно
      </button>
    </div>
  );
};
